import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { innings, PlayerName, number } from 'yankees-react-utils';
import GameLogsList from '../../../components/GameLogs';
import { hitFXERA, pitchFXERA } from '../../../utils/stats';

const StyledContainer = styled.div`
    width: 95%;
    margin: 8px auto;

    .stat-lines {
        font-size: 13px;
    }
`;

const getStatLines = (translate, game, showGameScore) => {
    let statLine = '';
    statLine += game.outs !== null ? `${innings(game.outs)} ${translate('baseball.abbr-inning-pitched')}, ` : '';
    statLine += game.so !== null ? `${game.so} ${translate('baseball.abbr-strikeout-k')}, ` : '';
    statLine += game.ubb !== null ? `${game.ubb} ${translate('baseball.abbr-walk')}, ` : '';
    statLine += game.hits !== null ? `${game.hits} ${translate('baseball.abbr-hits')}, ` : '';
    statLine += game.fbvelocity !== null ? `${translate('sections.reports.pitcher.abbr-velo')}: ${translate('format.abbr-mph', { value: number(game.fbvelocity, 1) })}, ` : '';
    statLine += game.rvgamefx !== null && game.pawrv !== null && showGameScore
        ? `${translate('sections.reports.pitcher.gamefx-era')}: ${number(hitFXERA(game.rvgamefx, game.pawrv), 2)}, ` : '';
    statLine += game.rvpitchfx != null && game.pitchfxwrv != null
        ? `${translate('home.pfx-era')}: ${number(pitchFXERA(game.rvpitchfx, game.pitchfxwrv), 2)}, ` : '';
    if (statLine.length >= 2) {
        statLine = statLine.substring(0, statLine.length - 2);
    }

    return [statLine];
};

const GameLogs = ({ pitcherId, pitcher }) => {
    const { t: translate } = useTranslation();
    const header = <h2 className="mb-0">{translate('sections.opponent.game-logs')}: <PlayerName player={pitcher} /></h2>;
    const gameWrapper = ({ children }) => <div className="d-flex">{children}</div>;

    return (
        <StyledContainer>
            {!!pitcherId && <GameLogsList playerId={+pitcherId} isPitcher header={header} gameWrapper={gameWrapper} getStatLines={getStatLines} />}
        </StyledContainer>
    );
};

export default GameLogs;
